import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      window.location.href = '/ops-portal/login'
    }
    return Promise.reject(error)
  }
)

// Public endpoints
export const createOnboardingRequest = async (formData: FormData) => {
  const response = await api.post('/onboarding', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const getOnboardingStatus = async (id: string) => {
  const response = await api.get(`/onboarding/${id}/status`)
  return response.data
}

export const getPipelineProgress = async (id: string) => {
  const response = await api.get(`/onboarding/${id}/pipeline`)
  return response.data
}

export const lookupByEmail = async (email: string) => {
  const formData = new FormData()
  formData.append('email', email)
  const response = await api.post('/onboarding/lookup', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

// Admin endpoints
export const listRequests = async (params?: {
  status?: string
  limit?: number
  offset?: number
}) => {
  const response = await api.get('/admin/requests', { params })
  return response.data
}

export const getRequestDetail = async (id: string) => {
  const response = await api.get(`/admin/requests/${id}`)
  return response.data
}

export const submitBwsToken = async (id: string, token: string) => {
  const response = await api.post(`/admin/requests/${id}/token`, {
    bws_token: token,
  })
  return response.data
}

export const getDemoConfig = async (): Promise<{
  enabled: boolean
  prefill: Record<string, string>
}> => {
  const response = await api.get('/onboarding/config/demo')
  return response.data
}

export const approveRequest = async (
  id: string,
  opts?: { notes?: string; targetHost?: string; piBaseUrl?: string; useLetsencrypt?: boolean; dnsEnabled?: boolean; acmeMode?: string }
) => {
  const body: Record<string, unknown> = {
    notes: opts?.notes,
    target_host: opts?.targetHost,
  }
  // Overrides optionnels (maquette / cas speciaux) : envoyes seulement si definis,
  // sinon le backend garde ses defauts (sandbox BCEAO / LE on / DNS on).
  if (opts?.piBaseUrl) body.pi_base_url = opts.piBaseUrl
  if (opts?.useLetsencrypt !== undefined) body.use_letsencrypt = opts.useLetsencrypt
  if (opts?.dnsEnabled !== undefined) body.dns_enabled = opts.dnsEnabled
  if (opts?.acmeMode) body.acme_mode = opts.acmeMode
  const response = await api.post(`/admin/requests/${id}/approve`, body)
  return response.data
}

export const deleteRequest = async (id: string) => {
  const response = await api.delete(`/admin/requests/${id}`)
  return response.data
}

export const confirmDeletion = async (id: string) => {
  const response = await api.post(`/admin/requests/${id}/confirm-deletion`)
  return response.data
}

export const listQualificationCandidates = async (params?: {
  category?: string
  limit?: number
  offset?: number
}) => {
  const response = await api.get('/admin/qualification-candidates', { params })
  return response.data
}

export const getQualificationCandidate = async (id: string) => {
  const response = await api.get(`/admin/qualification-candidates/${id}`)
  return response.data
}

export default api
